import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {FooterModuleStore} from './footer-module.store';
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {FooterModuleConfig} from "./footer-module.config";
import {FooterModuleHandlers} from "./handlers/footer-module.handlers";

export class FooterModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, FooterModuleConfig, FooterModuleStore, FooterModuleHandlers];

  gotoUrl(url: String): * {
    this.navigationManager.gotoUrl(url, false, true)
  }
}

